import { makeStyles } from '@mui/styles';

import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing }) => ({
    root: {
      border: '1px dashed black',
      borderRadius: 24,
      padding: spacing(1.25, 2),
      cursor: 'pointer',
      background: 'transparent',
      opacity: 0.54,
      width: '100%',
      textAlign: 'left',
      '&:hover, &:focus': {
        opacity: 1,
      },
      '&:active': {
        color: 'inherit',
      },
    },

    label: {
      display: 'inline-block',
    },

    icon: {
      '&> svg': {
        verticalAlign: 'top',
      },
      marginRight: spacing(1),
    },
  })
);

export default function HollowButton({ children, icon, ...otherProps }) {
  const classes = useStyles();

  return (
    <button
      className={classes.root}
      type="button"
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...otherProps}
    >
      <span className={classes.icon}>{icon}</span>
      <Typography variant="body" component="span" className={classes.label}>
        {children}
      </Typography>
    </button>
  );
}
